/* DesktopFilters.tsx generated by @compiled/babel-plugin v0.26.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import Button from '@atlaskit/button/new';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import React, { useCallback, useState } from 'react';
import { FilterPicker } from '../FilterPicker';
import { useIsMobile } from '../useIsMobile';
const clearFiltersButtonTextStyles = xcss({
  color: 'color.text.brand'
});
export const DesktopFilters = _ref => {
  let {
    filterDefinitions,
    filterOptions,
    filterStatus = {},
    onClearFilter: _onClearFilter,
    onClearAllFilters,
    onShowAllFilters,
    onSelectedOptionsChange,
    selectedOptions = {},
    showAllFilters
  } = _ref;
  const isMobile = useIsMobile();
  const [isAnyFilterOpen, setIsAnyFilterOpen] = useState(false);
  const visibleFilters = showAllFilters ? filterDefinitions : filterDefinitions.filter(_ref2 => {
    let {
      hiddenByDefault
    } = _ref2;
    return !hiddenByDefault;
  });
  const hasHiddenFilters = filterDefinitions.length > visibleFilters.length;
  const hasSelectedFilters = Object.keys(selectedOptions).some(filterId => {
    var _selectedOptions$filt;
    return (_selectedOptions$filt = selectedOptions[filterId]) === null || _selectedOptions$filt === void 0 ? void 0 : _selectedOptions$filt.length;
  });
  const handleClearAllFilters = () => {
    onClearAllFilters === null || onClearAllFilters === void 0 ? void 0 : onClearAllFilters({
      location: 'desktop'
    });
    setIsAnyFilterOpen(false);
  };
  const onPopupToggle = useCallback(isOpen => {
    if (isOpen) {
      setIsAnyFilterOpen(true);
    }
  }, [setIsAnyFilterOpen]);

  // isAnyFilterOpen -> false; when clear all filters is clicked
  // Close any open filter popup when clear all filters is clicked
  // else don't do anything
  const filterPopupState = !isAnyFilterOpen ? false : undefined;
  return /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    rowSpace: "space.100",
    shouldWrap: true
  }, visibleFilters.map(_ref3 => {
    let {
      filterId,
      label,
      isMulti,
      isSearchable,
      hasClearSelectionButton,
      groupSelectedItems
    } = _ref3;
    return /*#__PURE__*/React.createElement(FilterPicker, {
      key: filterId,
      label: label,
      isMulti: isMulti,
      isPopupOpen: isMobile ? false : filterPopupState,
      isSearchable: isSearchable,
      hasClearSelectionButton: hasClearSelectionButton,
      onPopupToggle: onPopupToggle,
      onChange: options => onSelectedOptionsChange({
        filterId,
        options,
        location: 'desktop'
      }),
      onClearFilter: () => _onClearFilter(filterId),
      options: filterOptions[filterId] || [],
      selectedOptions: selectedOptions[filterId] || [],
      status: filterStatus[filterId] || 'default',
      groupSelectedItems: groupSelectedItems
    });
  }), hasHiddenFilters && /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    onClick: onShowAllFilters
  }, "Show more filters"), hasSelectedFilters && /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    onClick: handleClearAllFilters
  }, /*#__PURE__*/React.createElement(Box, {
    as: "span",
    xcss: clearFiltersButtonTextStyles
  }, "Clear filters")));
};